import DirectionsOutlinedIcon from "@mui/icons-material/DirectionsOutlined";
import { Box, Button, Container, Typography } from "@mui/material";

export default function ContactMap() {
  return (
    <Box
      sx={{
        py: { xs: 3, md: 6 },
        backgroundColor: "var(--color-bg)",
        position: "relative",
      }}
    >
      <Container maxWidth="xl">
        {/* SECTION HEADER */}
        <Box
          sx={{
            maxWidth: 820,
            mx: { xs: 0, md: "auto" },
            textAlign: { xs: "left", md: "center" },
            mb: 6,
          }}
        >
          <Typography
            sx={{
              color: "var(--color-gold)",
              letterSpacing: "0.26em",
              fontSize: 12,
              mb: 2,
            }}
          >
            OUR LOCATION
          </Typography>

          <Typography
            sx={{
              color: "var(--color-text-primary)",
              fontSize: { xs: "2rem", md: "2.6rem" },
              fontWeight: 600,
              lineHeight: 1.15,
            }}
          >
            Visit Our Office in{" "}
            <Box component="span" sx={{ color: "var(--color-gold)" }}>
              Sharjah
            </Box>
          </Typography>

          <Typography
            sx={{
              color: "var(--color-text-muted)",
              fontSize: 15,
              lineHeight: 1.8,
              mt: 2,
              maxWidth: 620,
              mx: { xs: 0, md: "auto" },
            }}
          >
            Our office is located in the heart of Al Majaz 1, offering easy
            accessibility for clients across Sharjah and neighboring Emirates.
          </Typography>
        </Box>

        {/* MAP CARD */}
        <Box
          sx={{
            position: "relative",
            borderRadius: 4,
            overflow: "hidden",
            border: "1px solid rgba(207,172,106,0.45)",
            // boxShadow: "0 30px 80px rgba(0,0,0,0.15)",
            height: "460px",
          }}
        >
          {/* MAP */}
          <iframe
            title="Vision X Nexus Real Estate Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3605.8481165674975!2d55.38329977516854!3d25.34287717761747!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5be324388f91%3A0x15e581426ba21ef0!2sVision%20X%20Nexus%20Real%20Estate%20L.L.C!5e0!3m2!1sen!2sin!4v1768096109513!5m2!1sen!2sin"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            style={{
              width: "100%",
              height: "100%",
              border: 0,
            }}
          />

          {/* LOCATION INFO CARD */}
          <Box
            sx={{
              position: "absolute",
              bottom: 24,
              left: 24,
              right: { xs: 24, md: "auto" },
              maxWidth: 400,
              p: 3,
              borderRadius: 3,
              backgroundColor: "#ffffff",
              border: "1px solid rgba(207,172,106,0.45)",
              boxShadow: "0 20px 50px rgba(0,0,0,0.18)",
            }}
          >
            <Typography
              sx={{
                color: "var(--color-gold)",
                fontSize: 12,
                letterSpacing: "0.14em",
                mb: 1,
              }}
            >
              OUR OFFICE
            </Typography>

            <Typography
              sx={{
                color: "var(--color-text-primary)",
                fontSize: 14,
                lineHeight: 1.7,
                mb: 2,
              }}
            >
              Bell Rashid Towers – 1 Corniche St – Al Majaz 1 – Sharjah – UAE
            </Typography>

            <Button
              component="a"
              href="https://www.google.com/maps/place/Vision+X+Nexus+Real+Estate+L.L.C"
              target="_blank"
              startIcon={<DirectionsOutlinedIcon />}
              size="small"
              sx={{
                textTransform: "none",
                fontSize: 13,
                color: "var(--color-gold)",
                border: "1px solid rgba(207,172,106,0.45)",
                borderRadius: "30px",
                px: 2.5,
                "&:hover": {
                  backgroundColor: "rgba(207,172,106,0.12)",
                },
              }}
            >
              Get Directions
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
